import React from 'react';
import InfiniteScrollList from '../InfiniteScrollList';
import LogItem from './LogItem';
import useLocalization from '../../../hooks/useLocalization';

const Logs = ({ user, logs = [], disabled, onUndoRedoClick, onBottomReached, loadingMoreLogs }) => {
  const { translate } = useLocalization();
  return logs.length === 0 ? (
    <div style={{ height: 200 }} className="d-flex justify-content-center text-muted">
      <p className="align-self-center">{translate('no_any_logs')}</p>
    </div>
  ) : (
    <InfiniteScrollList
      items={logs}
      loadingMoreData={loadingMoreLogs}
      renderItem={l => (
        <LogItem
          user={user}
          log={l}
          key={l._id}
          disabled={disabled}
          onUndoRedoClick={action => onUndoRedoClick(action, l._id)}
        />
      )}
      onReachBottom={onBottomReached}
    />
  );
};

export default Logs;
